import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, tap } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { NewLandlord } from '../../model/newLandlord';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { BankIdStatus } from '../../model/bankid';

@Injectable()
export class AccountService {
  _endpoint: string;
  constructor(
    private _client: HttpClient,
    private _notification: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/account`;
  }

  bankIdAuthStatus(isMobile: boolean, thisUnit: boolean, orderReference: string): Observable<BankIdStatus> {
    return this._client.post<BankIdStatus>(`${this._endpoint}/bankid-status`, { isMobile, thisUnit, orderReference }).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this._notification.showError(errorResponse.error.message);
        }
        throw errorResponse;
      })
    );
  }

  bankIdCancel(orderReference: string): Observable<void> {
    return this._client.post<void>(`${this._endpoint}/bankid-cancel`, { orderReference });
  }

  private _post(model: any, path: string): Observable<any> {
    return this._client.post(this._endpoint + path, JSON.stringify(model));
  }

  private _put(model: any, path: string) {
    return this._client.put(this._endpoint + path, JSON.stringify(model));
  }

  changePassword(model: any): Observable<any> {
    return this._put(model, '/change-password');
  }

  forgotPassword(email: string): Observable<any> {
    return this._client.post(this._endpoint + '/forgot-password', JSON.stringify(email), {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  registerDemoAccount(model: any): Observable<any> {
    return this._client.post(this._endpoint + '/registerdemo', JSON.stringify(model), { headers: { 'Content-Type': 'application/json' } });
  }

  getAccountDefinition(): Observable<any> {
    return this._client.get(`${this._endpoint}/definition`);
  }

  register(model: NewLandlord): Observable<any> {
    return this._post(model, '/register');
  }

  resetPassword(model: any): Observable<any> {
    return this._client.put(this._endpoint + '/reset-password', model, { headers: { 'Content-Type': 'application/json' } });
  }

  support(form: any): Observable<any> {
    return this._client.post(`${this._endpoint}/support`, JSON.stringify(form)).pipe(
      tap(() => {
        this._notification.showSuccess('SUPPORT.MESSAGE_SUCCESS');
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) {
          this._notification.showError(errorResponse.error.message);
        }
        throw errorResponse;
      })
    );
  }

  validateEmail(email: string): Observable<string> {
    return this._client.get(`${this._endpoint}/validate-email`, {
      params: new HttpParams().set('email', email),
      responseType: 'text',
    });
  }

  validatePassword(password: string): Observable<string> {
    return this._client.get(`${this._endpoint}/validate-password`, {
      params: new HttpParams().set('password', password),
      responseType: 'text',
    });
  }
}
